import {Component, ElementRef, inject, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ErrorService} from "../../../../services/error/error.service";
import {AuthControllerService, User} from '../../../../api';
import {BicButtonComponent, BicPopupComponent} from "@buildinginformationcloud/bic-ui-components";


@Component({
  selector: 'app-fta-popup-deactivate',
  templateUrl: './fta-popup-deactivate.component.html',
  styleUrls: ['./fta-popup-deactivate.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [

    ReactiveFormsModule,
    BicButtonComponent,
    BicPopupComponent

  ]
})
export class FtaPopupDeactivateComponent implements OnInit {
  data = inject<{
    changeMethode: boolean;
    user: User;
    methode: String;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<FtaPopupDeactivateComponent>>(MatDialogRef);
  formBuilder = inject(UntypedFormBuilder);
  private authControllerService = inject(AuthControllerService);
  private errorService = inject(ErrorService);


  changeMethode: boolean = false;
  enterCode: boolean = false;
  mfaForm!: UntypedFormGroup;
  mfaError: boolean = false;
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  isApproveLoading = false;
  isVerifyLoading = false;

  ngOnInit(): void {
    this.changeMethode = this.data.changeMethode;
    this.mfaForm = this.formBuilder.group({
      code1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      code2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      code3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      code4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      code5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      code6: ['', [Validators.required, Validators.pattern(/^\d$/)]]
    });
  }

  deactivate2FA(): void {
    this.authControllerService.deactivate2FA().subscribe(() => {
      if(this.changeMethode){
        this.dialogRef.close({success: true, activateOtherMethod: true});
      }else{
        this.dialogRef.close({success: true, activateOtherMethod: false});
      }
    });
  }

  approve(): void {
    if(this.data.methode == 'tfaApp' && this.changeMethode || this.data.methode == 'tfaMail' && !this.changeMethode){
      this.isApproveLoading = true;
      this.authControllerService.resendCode(this.data!.user!.mail ?? '').subscribe({
        next: () => {
          this.isApproveLoading = false;
          this.enterCode = true;
        },
        error: () => {
          this.isApproveLoading = false;
        }
      });
    }else{
      this.enterCode = true;
    }
  }

  verify(): void {
    if(this.mfaForm.valid){
      this.isVerifyLoading = true;
      this.errorService.errorEvent$.subscribe((error) => {
        if (error.status == 401) {
          this.mfaError = true;
          this.isVerifyLoading = false;
        }
      });


      const code = '' + this.mfaForm.value.code1 + this.mfaForm.value.code2 + this.mfaForm.value.code3 + this.mfaForm.value.code4 + this.mfaForm.value.code5 + this.mfaForm.value.code6;
      this.authControllerService.verify2FA({
        username: this.data.user.mail,
        password: '',
        verificationCode: code
      }).subscribe({
        next: () => {
          this.isVerifyLoading = false;
          this.deactivate2FA();
        },
        error: () => {
          this.isVerifyLoading = false;
        }
      });
    }
  }

  moveToNext(event: any, index: number): void {
    const input = event.target;
    const key = event.key;

    if (input.value.length > 1) {
      input.value = input.value.slice(0, 1);
    }


    if (event.type === 'paste') {
      const pasteData = (event as ClipboardEvent).clipboardData?.getData('text');

      const textWithoutSpaces = pasteData!.replace(/\s+/g, '');
      if (textWithoutSpaces && textWithoutSpaces.length === 6) {
        for (let i = 0; i < 6; i++) {
          this.mfaForm.controls[`code${i + 1}`].setValue(textWithoutSpaces[i]);
        }
        this.otpInputs.toArray()[5].nativeElement.focus();
        event.preventDefault();
      }
      return;
    }

    if (key === 'Backspace' && input.value.length === 0 && index > 0) {
      this.otpInputs.toArray()[index - 1].nativeElement.focus();
    } else if (input.value.length === 1 && index < 5) {
      this.otpInputs.toArray()[index + 1].nativeElement.focus();
    }
  }

  close(): void {
    this.dialogRef.close({success: false});
  }

}
